// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nonerp-review-mapping {
  display: flex;
}
.nonerp-review-mapping .modals-wrap {
  width: 100%;
}
.nonerp-review-mapping .modal-main {
  padding-inline: 0;
  padding-block: 18px 0px;
  top: auto;
}
.nonerp-review-mapping .modal-main:has(.nonerp-review-mapping-list) {
  max-width: 680px;
  min-width: 680px;
}
.nonerp-review-mapping .modal-close-btn {
  color: #333333;
  height: 21px;
  width: 23px;
  top: 17px;
}
.nonerp-review-mapping .modal-header {
  display: block;
  margin-bottom: 0px;
  margin-inline: -3px;
  padding-inline: 37px;
  border-bottom: 1px solid #D2D2D2;
  padding-bottom: 17px;
  text-align: center;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.18px;
}
.nonerp-review-mapping .modal-content {
  padding-inline: 37px;
  margin-inline: -3px;
  padding-block: 20px;
  font-family: var(--font-family);
}
.nonerp-review-mapping .radio-option-product-img-title-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
}
.nonerp-review-mapping .radio-option-product-img {
  max-width: 81px;
  max-height: 81px;
  height: 100%;
  width: 100%;
  padding: 18px 10px;
  border-radius: 6px;
  background: #F8F8F8;
  border: 1px solid #F8F8F8;
}
.nonerp-review-mapping .radio-option-product-title {
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #333;
  max-width: 182px;
}
.nonerp-review-mapping .modal-content {
  overflow-y: auto;
  max-height: 66vh;
}
.nonerp-review-mapping .product_status {
  margin-bottom: 10px;
}
.nonerp-review-mapping .modal-content::-webkit-scrollbar-thumb {
  background-color: #ACACAC;
  width: 6px;
}
.nonerp-review-mapping .modal-content::-webkit-scrollbar {
  width: 6px;
  background: #EFEFEF;
  border-radius: 10px;
}
.nonerp-review-mapping .modal-button-wrap button {
  width: 100%;
  max-width: 194px;
  border-radius: 60px;
  background: #6ECB44;
  color: #FFF;
  text-align: center;
  font-family: var(--font-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  padding-block: 12px;
  margin-block: 21px 18px;
}
.nonerp-review-mapping .modal-button-wrap {
  display: flex;
  justify-content: center;
  border-top: 1px solid #D2D2D2;
  margin-inline: -3px;
}
.nonerp-review-mapping input::-webkit-search-cancel-button {
  display: none;
}
.nonerp-review-mapping .change-erp-product-price-popup span.mat-prefix,
.nonerp-review-mapping .non-erp-newly-mapped span.mat-prefix {
  width: 38px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px 0px 0px 5px;
  border-right: 1px solid #D2D2D2;
  background: #EDEDED;
  justify-content: center;
  margin-right: 4px;
}
.nonerp-review-mapping .change-erp-product-price-popup span.mat-prefix {
  border-right: none;
  margin-right: 0px;
  width: auto;
  padding-left: 10px;
  background-color: inherit;
}
.nonerp-review-mapping .nonerp-review-mapping-list .modal-content-header {
  font-family: var(--font-family);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27.5px;
  text-align: center;
  max-width: 380px;
  margin: auto;
  margin-bottom: 20px;
}
.nonerp-review-mapping .nonerp-review-mapping-list .modal-content-header:has(+ .custom-form-error) {
  margin-bottom: 0;
}
.nonerp-review-mapping .nonerp-review-mapping-list .custom-form-error {
  font-family: var(--font-family);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  padding-block: 0;
  color: #dc3545;
  text-align: center;
  margin-bottom: 20px;
}
.nonerp-review-mapping .nonerp-review-mapping-list .load-more-btn {
  display: flex;
  margin-block: 10px;
  justify-content: center;
}
.nonerp-review-mapping .nonerp-review-mapping-list .load-more-btn button {
  border-radius: 5px;
  border: 1px solid #6ECB44;
  background: #FFF;
  color: #6ECB44;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  max-width: 160px;
  margin: auto;
}
.nonerp-review-mapping .nonerp-review-mapping-list .mat-mdc-radio-button .mdc-form-field {
  width: 100%;
}
.nonerp-review-mapping .nonerp-review-mapping-list .radio-option-title-input-grp {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

@media screen and (max-width: 767px) {
  .nonerp-review-mapping .nonerp-review-mapping-list .radio-option-title-input-grp {
    flex-direction: column;
    align-items: start;
    gap: 15px;
    max-width: 182px;
  }
  .nonerp-review-mapping .modal-main:has(.nonerp-review-mapping-list) {
    max-width: 480px;
    min-width: 480px;
  }
  .nonerp-review-mapping .radio-option-product-img-title-wrap {
    justify-content: space-between;
  }
  .nonerp-review-mapping .modal-content {
    padding-inline: 25px;
  }
}
@media screen and (max-width: 592px) {
  .nonerp-review-mapping .modal-main:has(.nonerp-review-mapping-list) {
    max-width: 400px;
    min-width: 400px;
  }
}
@media screen and (max-width: 492px) {
  .nonerp-review-mapping .modal-main {
    max-width: 330px;
  }
  .nonerp-review-mapping .modal-main:has(.nonerp-review-mapping-list) {
    max-width: 330px;
    min-width: 330px;
  }
  .nonerp-review-mapping .change-erp-product-price-popup .modal-content-main.data_filter {
    flex-direction: column;
    gap: 15px;
  }
  .nonerp-review-mapping .modal-content {
    padding-inline: 15px;
  }
  .nonerp-review-mapping .radio-option-product-img-title-wrap {
    gap: 15px;
    margin-left: 10px;
  }
  .nonerp-review-mapping .modal-header {
    font-size: 15px;
  }
  .nonerp-review-mapping .map-erp-product-popup .modal-content-header,
  .nonerp-review-mapping .nonerp-review-mapping-list .modal-content-header {
    font-size: 14px;
    line-height: 20px;
  }
}
.product_status {
  text-align: center;
  font-size: 16px;
  opacity: 0.5;
}

.nonerp-review-mapping-list .modal-content-header {
  color: #000;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27.5px;
  text-align: center;
  max-width: 380px;
  margin: auto;
  margin-bottom: 20px;
}
.nonerp-review-mapping-list .mat-mdc-radio-button .mdc-form-field {
  width: 100%;
}
.nonerp-review-mapping-list .radio-option-title-input-grp {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/products/nonerp-review-mapping/nonerp-review-mapping.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAAI;EACI,WAAA;AAER;AACI;EACI,iBAAA;EAEA,uBAAA;EACA,SAAA;AAAR;AACQ;EACI,gBAAA;EACA,gBAAA;AACZ;AAGI;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AADR;AAGI;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AADR;AAGI;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,+BAAA;AADR;AAKI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;AAHR;AAKI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;AAHR;AAKI;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AAHR;AAMI;EACI,gBAAA;EACA,gBAAA;AAJR;AASI;EACI,mBAAA;AAPR;AASI;EAEI,yBAAA;EACA,UAAA;AARR;AAUI;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;AARR;AAWI;EACI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;AATR;AAWI;EACI,aAAA;EACA,uBAAA;EACA,6BAAA;EACA,mBAAA;AATR;AAWI;EACI,aAAA;AATR;AAWI;;EAEQ,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AATZ;AAWI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AATR;AAaQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAXZ;AAaQ;EACI,gBAAA;AAXZ;AAaQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAXZ;AAaQ;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;AAXZ;AAaQ;EACI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAXZ;AAaQ;EACI,WAAA;AAXZ;AAaQ;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AAXZ;;AAkBA;EAIY;IACI,sBAAA;IACA,kBAAA;IACA,SAAA;IACA,gBAAA;EAlBd;EAsBU;IACI,gBAAA;IACA,gBAAA;EApBd;EAuBM;IACI,8BAAA;EArBV;EAuBM;IACI,oBAAA;EArBV;AACF;AA0BA;EAKY;IACI,gBAAA;IACA,gBAAA;EA5Bd;AACF;AAgCA;EAEQ;IACI,gBAAA;EA/BV;EAgCU;IACI,gBAAA;IACA,gBAAA;EA9Bd;EAoCU;IACI,sBAAA;IACA,SAAA;EAlCd;EAqCM;IACI,oBAAA;EAnCV;EAqCM;IACM,SAAA;IACA,iBAAA;EAnCZ;EAqCM;IACI,eAAA;EAnCV;EAwCU;;IACI,eAAA;IACA,iBAAA;EArCd;AACF;AA8CA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AA5CJ;;AAgDI;EACI,WAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA7CR;AA+CI;EACI,WAAA;AA7CR;AA+CI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AA7CR","sourcesContent":[".nonerp-review-mapping{\n    display: flex;\n    .modals-wrap{\n        width: 100%;\n        \n    }   \n    .modal-main{\n        padding-inline: 0;\n        \n        padding-block: 18px 0px;\n        top: auto;\n        &:has(.nonerp-review-mapping-list){\n            max-width: 680px;\n            min-width: 680px;\n        }\n       \n    }\n    .modal-close-btn {\n        color: #333333;\n        height: 21px;\n        width: 23px;\n        top: 17px;\n    }\n    .modal-header {\n        display: block;\n        margin-bottom: 0px;\n        margin-inline: -3px;\n        padding-inline: 37px;\n        border-bottom: 1px solid #D2D2D2;\n        padding-bottom: 17px;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0.18px;\n    }\n    .modal-content {\n        padding-inline: 37px;\n        margin-inline: -3px;\n        padding-block: 20px;\n        font-family:  var(--font-family);\n       \n    }\n  \n    .radio-option-product-img-title-wrap {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n        margin-bottom: 20px;\n        margin-left: 20px;\n    }\n    .radio-option-product-img {\n        max-width: 81px;\n        max-height: 81px;\n        height: 100%;\n        width: 100%;\n        padding: 18px 10px;\n        border-radius: 6px;\n        background: #F8F8F8;\n        border: 1px solid #F8F8F8;\n    }\n    .radio-option-product-title {\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        color: #333;\n        max-width: 182px;\n    }\n\n    .modal-content {\n        overflow-y: auto;\n        max-height: 66vh;\n        // min-height: 66vh;\n\n    }\n    \n    .product_status {\n        margin-bottom: 10px;\n    }\n    .modal-content::-webkit-scrollbar-thumb\n    {\n        background-color:#ACACAC;\n        width: 6px;\n    }\n    .modal-content::-webkit-scrollbar {\n        width: 6px;\n        background: #EFEFEF;\n        border-radius: 10px;\n    }\n  \n    .modal-button-wrap button {\n        width: 100%;\n        max-width: 194px;\n        border-radius: 60px;\n        background: #6ECB44;\n        color: #FFF;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        letter-spacing: 0.7px;\n        text-transform: uppercase;\n        padding-block: 12px;\n        margin-block: 21px 18px;\n    }\n    .modal-button-wrap {\n        display: flex;\n        justify-content: center;\n        border-top: 1px solid #D2D2D2;\n        margin-inline: -3px;\n    }\n    input::-webkit-search-cancel-button{\n        display: none;\n    }\n    .change-erp-product-price-popup  span.mat-prefix,\n    .non-erp-newly-mapped span.mat-prefix {\n            width: 38px;\n            height: 40px;\n            display: flex;\n            align-items: center;\n            border-radius: 5px 0px 0px 5px;\n            border-right: 1px solid #D2D2D2;\n            background: #EDEDED;\n            justify-content: center;\n            margin-right: 4px;\n    }\n    .change-erp-product-price-popup span.mat-prefix{\n        border-right:none;\n        margin-right: 0px;\n        width: auto;\n        padding-left: 10px;\n        background-color: inherit;\n    }\n    \n    .nonerp-review-mapping-list{\n        .modal-content-header {\n            font-family:  var(--font-family);\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 27.5px;\n            text-align: center;\n            max-width: 380px;\n            margin: auto;\n            margin-bottom: 20px;\n        }\n        .modal-content-header:has( + .custom-form-error){\n            margin-bottom: 0;\n        }\n        .custom-form-error {\n            font-family:  var(--font-family);\n            font-size: 10px;\n            font-style: normal;\n            font-weight: 500;\n            padding-block: 0;\n            color: #dc3545;\n            text-align: center;\n            margin-bottom: 20px;\n        }\n        .load-more-btn {\n            display: flex;\n            margin-block: 10px;\n            justify-content: center;\n        }\n        .load-more-btn button {\n            border-radius: 5px;\n            border: 1px solid #6ECB44;\n            background: #FFF;\n            color: #6ECB44;\n            text-align: center;\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 20px;\n            max-width: 160px;\n            margin: auto;\n        }\n        .mat-mdc-radio-button .mdc-form-field{\n            width: 100%;\n        }\n        .radio-option-title-input-grp{\n            display: flex;\n            justify-content: space-between;\n            width: 100%;\n            align-items: center;\n        }\n    }\n \n    \n}\n\n@media screen and (max-width:767px) {\n    .nonerp-review-mapping{\n        .nonerp-review-mapping-list\n        {   \n            .radio-option-title-input-grp{\n                flex-direction: column;\n                align-items: start;\n                gap: 15px;\n                max-width: 182px;\n            }\n        }\n        .modal-main{\n            &:has(.nonerp-review-mapping-list){\n                max-width: 480px;\n                min-width: 480px;\n            }\n        }\n        .radio-option-product-img-title-wrap{\n            justify-content: space-between;\n        }\n        .modal-content{\n            padding-inline: 25px;\n        }\n    }\n   \n}\n\n@media screen and (max-width:592px) {\n    .nonerp-review-mapping{\n       \n        .modal-main{\n         \n            &:has(.nonerp-review-mapping-list){\n                max-width: 400px;\n                min-width: 400px;\n            }\n        }\n    }\n}\n@media screen and (max-width:492px) {\n    .nonerp-review-mapping{\n        .modal-main{\n            max-width: 330px;\n            &:has(.nonerp-review-mapping-list){\n                max-width: 330px;\n                min-width: 330px;\n            }\n           \n        }\n        .change-erp-product-price-popup\n          {\n            .modal-content-main.data_filter {\n                flex-direction: column;\n                gap: 15px;\n            }\n         }\n        .modal-content{\n            padding-inline: 15px;\n        }\n        .radio-option-product-img-title-wrap{\n              gap: 15px;\n              margin-left: 10px;\n        }\n        .modal-header{\n            font-size: 15px;\n        }\n  \n        .map-erp-product-popup,\n        .nonerp-review-mapping-list{\n            .modal-content-header{\n                font-size: 14px;\n                line-height: 20px;\n            \n            }\n        }\n    }\n\n\n}\n\n\n.product_status{\n    text-align: center;\n    font-size: 16px;\n    opacity: .5;\n}\n\n.nonerp-review-mapping-list{\n    .modal-content-header {\n        color: #000;\n        font-family:  var(--font-family);\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 27.5px;\n        text-align: center;\n        max-width: 380px;\n        margin: auto;\n        margin-bottom: 20px;\n    }\n    .mat-mdc-radio-button .mdc-form-field{\n        width: 100%;\n    }\n    .radio-option-title-input-grp{\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        align-items: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
